<template lang="pug">
	.upload-test(v-if="showed && Project.SelectedProject")
		.card
			.card-header
				i.fa.fa-edit
				span TamperMonkey upload
			.card-body.collapse.show(v-if="state === 'preparing' || state === 'release' || state === 'uploading'")
				.processing
					.icon.fa.fa-spinner.fa-spin
					.text(v-if="state === 'preparing'") preparing...
					.text(v-if="state === 'release'") creating release...
					.text(v-if="state === 'uploading'") uploading...
			.card-body.collapse.show(v-if="state === 'result'")
				.result
					.text(v-if="result && result.type === 'tag'")
						textarea {{result.data}}
					.text(v-if="result && result.type === 'file-link'")
						a(v-bind:href="resultFileLink" target="_blank") {{resultTag}}
				.form-horizontal
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="copy()")
							i.fa.fa-copy
							| &nbsp;&nbsp;Copy
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

import Screen 				from './../../mixins/screen'

import { Server } 			from './../../services/Server'

import { Template } 		from './../../services/Template'
import { Project } 			from './../../services/Project'
import { Layout } 			from './../../services/Layout'

import NetworkList 			from './../Shared/NetworksList'

import SetupSettings 		from '../../settings/settings'

export default {
	name: "UploadTest",
	mixins: [Screen],
	screen: {
		events: {
			"Amazon Upload Progress": function(data) {

				if (data && data.UploadProjectFolder !== 'tampermonkey') this.close();

				if (data.UploadProjectId === Project.SelectedProject.id && data.UploadProjectFolder === 'tampermonkey') {

					this.state = data.UploadProgress;

					if (data.UploadResult) this.result = data.UploadResult;

					//console.log('this.state', this.state);

					this.update();

				}

			},

			"Upload Test": function() {

				this.upload();

			}
		}
	},
	components: {
		NetworkList
	},

	data() {

		this.Server = Server;
		this.Template = Template;
		this.Project = Project;
		this.TemplateFolder = 'test';
		this.ProjectFolder = 'tampermonkey';
		this.ReleaseType = 'js-normal';
		this.Region = Server.Config['amazon-s3-bucket-region'] || 'eu-central-1';

		this.result = {};

		return {
			showed: false,
			state: 'preparing' //'preparing', 'release', 'uploading', 'result'
		};

	},
	computed: {
		previewFileLink() {
			return `https://cdn.prvk.io/${this.TemplateFolder}/${this.ProjectFolder}/`;
		},
		resultFileLink() {
			return `https://cdn.prvk.io/${this.result.templateFolder}/${this.result.projectFolder}/${this.result.data}`;
		},
		resultTag() {
			return `<script src="${this.resultFileLink}" async>`;
		}
	},
	methods: {
		upload() {

			Server.sendToSocket({
				UploadCreative: {
					uploadTo: 'amazon',
					projectId: Project.SelectedProject.id,
					releaseType: this.ReleaseType,
					templateFolder: this.TemplateFolder,
					projectFolder: this.ProjectFolder,
					region: this.Region
				}
			});

			this.state = 'preparing';

		},

		close() {

			this.state = 'preparing';

			this.hide();

		}
	}
}
</script>

<style lang="sass">

.upload-test
	position: absolute
	z-index: 2000
	left: 0
	top: 0
	right: 0
	bottom: 0
	background-color: rgba(0, 0, 0, 0.6)

	.card
		width: 500px
		position: absolute
		left: 0
		right: 0
		top: 0
		bottom: 0
		margin: auto
		display: flex
		height: 400px
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

		input
			width: 460px
			margin-top: 5px

		.btn-dark
			float: right
			color: #fff

		.form-actions
			position: absolute
			right: 19px
			bottom: 20px
			width: calc(100% - 40px)

	.processing
		height: 100%
		display: flex
		flex-direction: column
		align-items: center
		justify-content: center

		.icon
			display: inline
			font-size: 30px

	.result

		textarea
			width: 100%
			height: 250px
			background: transparent
			border: none
			color: #fff
			font-size: 12px
			white-space: pre
			overflow-wrap: normal
			overflow-x: auto
</style>
